import React, { useState, useEffect, useRef, Fragment } from 'react';

/**
 * Initializes the styles for button and span.
 *
 * @return {object} Object containing the styles
 */
const initStyles = () => {
    return { background: '#585858' };
};

/**
 * Initializes the styles for the popup box.
 *
 * @return {object} Object containing the styles
 */
const initPopupStyle = () => {
    return { left: '68%', top: '90%' };
};

/**
 * Functional component that initializes the Info/Question button.
 *
 * useRef hook is used to store the reference to the button element.
 * useEffect hook sets the styles for the component if they change, also adds eventlistener
 * for outside info button clicks and cleans it up after button is not rendered
 *
 * @param {object} props - properties for the component
 */
const QuestionButton = (props) => {
    const [infoToggled, setToggled] = useState(false);
    const [textInfo, setInfoText] = useState('');
    const [btnStyle, setBtnStyle] = useState(() => initStyles());
    const [spanStyle, setSpanStyle] = useState(() => initStyles());
    const [popupStyle, setPopupStyle] = useState(() => initPopupStyle());

    const node = useRef();

    const { infoText, styleSpan, styleBtn, stylePopup } = props;

    /**
     * Check if clicked outside of the info button, closes the info box
     *
     * @param {*} e - the event (onClick)
     */
    const handleOutsideClick = (e) => {
        if (node.current.contains(e.target)) {
            return;
        }
        setToggled(false);
    };

    useEffect(() => {
        styleBtn ? setBtnStyle(styleBtn) : initStyles();
        styleSpan ? setSpanStyle(styleSpan) : initStyles();
        infoText ? setInfoText(infoText) : setInfoText('');
        stylePopup ? setPopupStyle(stylePopup) : initPopupStyle();

        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [infoText, styleBtn, styleSpan, stylePopup]);

    return (
        <Fragment>
            <button
                ref={node}
                type="button"
                className="btn btn-lg btn-primary button-group-info-popover-button"
                style={btnStyle}
                onClick={() => setToggled(!infoToggled)}>
                <span className="button-group-info-popover-logo" title={textInfo} style={spanStyle}>
                    ?
                </span>
            </button>
            {infoToggled && (
                <div className="popover fade bottom in" id="bottom-pop" style={popupStyle}>
                    <div className="arrow" id="left-arrow"></div>
                    <div className="popover-content">
                        <p className="black-p">{textInfo}</p>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default QuestionButton;
